import angular from 'angular';
import {logger} from './logger.js';

const module = angular.module('logger', []);

module.service('logger', ['$filter', function ($filter) {
    return {
        error: (title, data) => {
            logger.error(title, $filter('json')(data));
        }
    };
}]);

export default module;



// WEBPACK FOOTER //
// ./app/components/common/logger/logger.service.js